import React from 'react';
import { Cookie } from 'lucide-react';
import { SEO } from '../../components/SEO';

function PravilaKolacica() {
  return (
    <>
      <SEO 
        title="Pravila Kolačića | Online Kalkulator"
        description="Pravila kolačića Online Kalkulatora. Saznajte kako koristimo kolačiće i druge tehnologije praćenja na našoj web stranici."
        canonicalUrl="/pravila-kolacica"
      />
      <div className="max-w-4xl mx-auto px-4">
        <div className="flex items-center justify-center gap-3 mb-6">
          <Cookie className="w-8 h-8 text-blue-600" />
          <h1 className="text-3xl font-bold text-gray-800 text-center">Pravila Kolačića</h1>
        </div>

        <div className="bg-white rounded-xl shadow-lg p-8">
          <div className="prose max-w-none">
            <p className="text-gray-600 mb-6">
              Posljednje ažuriranje: {new Date().toLocaleDateString('hr-HR')}
            </p>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">1. Što su Kolačići</h2>
              <p className="text-gray-600">
                Kolačići su male tekstualne datoteke koje se pohranjuju na vašem računalu ili mobilnom
                uređaju kada posjetite web stranicu. Široko se koriste kako bi web stranice radile
                učinkovitije i pružile bolju korisničku uslugu.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">2. Vrste Kolačića koje Koristimo</h2>
              <div className="space-y-4">
                <div>
                  <h3 className="text-xl font-medium text-gray-800 mb-2">Nužni kolačići</h3>
                  <p className="text-gray-600">
                    Ovi kolačići su neophodni za funkcioniranje web stranice i ne mogu se isključiti.
                    Obično se postavljaju samo kao odgovor na vaše akcije koje predstavljaju zahtjev za
                    uslugama.
                  </p>
                </div>
                <div>
                  <h3 className="text-xl font-medium text-gray-800 mb-2">Analitički kolačići</h3>
                  <p className="text-gray-600">
                    Pomažu nam razumjeti kako posjetitelji koriste našu web stranicu. Sve informacije
                    koje ovi kolačići prikupljaju su anonimne.
                  </p>
                </div>
                <div>
                  <h3 className="text-xl font-medium text-gray-800 mb-2">Funkcionalni kolačići</h3>
                  <p className="text-gray-600">
                    Omogućuju web stranici da zapamti vaše izbore kako bi vam pružila poboljšane i
                    personalizirane značajke.
                  </p>
                </div>
                <div>
                  <h3 className="text-xl font-medium text-gray-800 mb-2">Oglašivački kolačići</h3>
                  <p className="text-gray-600">
                    Naša web stranica koristi Google AdSense za prikazivanje oglasa. Google AdSense koristi kolačiće za prikazivanje relevantnih oglasa na temelju vaših interesa i aktivnosti na internetu. Ovi kolačići također pomažu u mjerenju učinkovitosti oglašavačkih kampanja.
                  </p>
                </div>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">3. Google AdSense i Kolačići</h2>
              <p className="text-gray-600 mb-4">
                Google AdSense koristi kolačiće za sljedeće svrhe:
              </p>
              <ul className="list-disc list-inside text-gray-600 space-y-2">
                <li>Prikazivanje oglasa koji su relevantni za vas i vaše interese</li>
                <li>Ograničavanje broja prikaza određenog oglasa</li>
                <li>Mjerenje učinkovitosti oglasa</li>
                <li>Razumijevanje kako korisnici koriste web stranicu</li>
                <li>Sprječavanje prijevara i poboljšanje sigurnosti</li>
              </ul>
              <p className="text-gray-600 mt-4">
                Google i njegovi partneri za oglašavanje mogu postavljati kolačiće na vašem uređaju za prikazivanje oglasa na našoj web stranici. Za više informacija o Google AdSense kolačićima, posjetite <a href="https://policies.google.com/technologies/ads" target="_blank" rel="nofollow noopener noreferrer" className="text-blue-600 hover:underline">Google Pravila o oglašavanju</a>.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">4. Kako Upravljati Kolačićima</h2>
              <p className="text-gray-600 mb-4">
                Većina web preglednika omogućuje vam kontrolu nad kolačićima kroz postavke preglednika.
                Možete:
              </p>
              <ul className="list-disc list-inside text-gray-600 space-y-2">
                <li>Vidjeti koje kolačiće imate i pojedinačno ih izbrisati</li>
                <li>Blokirati kolačiće trećih strana</li>
                <li>Blokirati kolačiće s određenih web stranica</li>
                <li>Blokirati postavljanje svih kolačića</li>
                <li>Izbrisati sve kolačiće kada zatvorite preglednik</li>
              </ul>
              <p className="text-gray-600 mt-4">
                Za oglašivačke kolačiće, možete posjetiti <a href="https://www.youronlinechoices.com" target="_blank" rel="nofollow noopener noreferrer" className="text-blue-600 hover:underline">www.youronlinechoices.com</a> ili <a href="https://www.aboutads.info/choices/" target="_blank" rel="nofollow noopener noreferrer" className="text-blue-600 hover:underline">www.aboutads.info/choices/</a> za više informacija o personaliziranom oglašavanju i mogućnostima isključivanja.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">5. Posljedice Isključivanja Kolačića</h2>
              <p className="text-gray-600">
                Ako odlučite isključiti određene kolačiće, neki dijelovi naše web stranice možda neće
                raditi ispravno. Posebno, nećemo moći spremiti vaše postavke i preferencije. Isključivanje oglašivačkih kolačića može rezultirati prikazivanjem manje relevantnih oglasa, ali oglasi će se i dalje prikazivati.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">6. Promjene Pravila Kolačića</h2>
              <p className="text-gray-600">
                Možemo ažurirati ova Pravila kolačića s vremena na vrijeme. Kada napravimo promjene,
                ažurirat ćemo datum "Posljednje ažuriranje" na vrhu ove stranice.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">7. Kontakt</h2>
              <p className="text-gray-600">
                Ako imate pitanja o našoj upotrebi kolačića, možete nas kontaktirati:
              </p>
              <ul className="list-disc list-inside text-gray-600 mt-4">
                <li>E-poštom: kontakt@backspace-media.com</li>
              </ul>
            </section>
          </div>
        </div>
      </div>
    </>
  );
}

export default PravilaKolacica;